<template>
  <div
      class="ClientesAptosTransacionar"
      v-loading="isLoading"
      style="padding: 10px; background: #fff; border-radius: 8px;"
  >
    <h3 style="text-align: center; margin-bottom: 1rem">Clientes Aptos a Transacionar</h3>
    <div class="mb-20" style="display: flex; justify-content: center">
      <apexchart
          height="300"
          width="400"
          type="bar"
          :options="chartOptions"
          :series="seriesBar"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import {getClientsEnabledTransactions} from "../../../services";
import { makeErrorFilds } from "@/app/plugins/utils";

  export default {
    name: 'ClientesAptosTransacionar',

    data() {
      return {
        isLoading: false,
        boxAtualStyle: {
          background: "var(--primary-color)",
          color: "var(--secondary-color)",
        },

        chartOptions: {
          style: {
            colors: ["#304758"],
          },
          tooltip: {
            enabled: true,
          },
          chart: {
            id: "clientes-ativos-chart-bar",
            type: "bar",
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              dataLabels: {
                position: 'center',
              },
            }
          },
          xaxis: {
            tickPlacement: "between",
          },
          yaxis: {
            labels: {},
          },
          legend: {
            show: true,
            position: "bottom",
          },
          dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
              fontSize: "12px",
            },
          },
        },
        seriesBar: [],
      }
    },

    async beforeMount() {
      this.isLoading = true;
      try {
        let response = await getClientsEnabledTransactions();

        const chartArray = Object.values(response.data);
        const transformedArray = chartArray.map((x) => {
          let month = x.month.split("/")[0] + "/01/" + x.month.split("/")[1]
          return {
            x: this.$moment.utc(month).format("MMMM").toUpperCase(),
            y: parseFloat(x.value),
          };
        });

        this.seriesBar.push({
          name: "Clientes Aptos a Transacionar",
          data: transformedArray,
        });
      } catch (e) {
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        this.isLoading = false;
      }
    },
  }
</script>

<style scoped>

</style>